import { render, staticRenderFns } from "./Recommend.vue?vue&type=template&id=e2c4f930&scoped=true&"
import script from "./Recommend.vue?vue&type=script&lang=js&"
export * from "./Recommend.vue?vue&type=script&lang=js&"
import style0 from "./Recommend.vue?vue&type=style&index=0&id=e2c4f930&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c4f930",
  null
  
)

export default component.exports